export const SET_DTM_USERINFO = 'SET_DTM_USERINFO';
export const RESET_DTM_USERINFO = 'RESET_DTM_USERINFO';
export const GET_LP_DATE = 'GET_LP_DATE';
export const SET_LP_DATE = 'SET_LP_DATE';
export const SET_PLATFORM = 'SET_PLATFORM'; // used to differentiate msite from app webview
